import { riskProfileClickHandler } from "../utilities/helpers"
import RiskProfileModal from "./RiskProfileModal"

export default function RiskProfileColors() {
    return (
        <>
            <RiskProfileModal />
            <div
                className="text-end"
                style={{ height: "0.5rem", float: "right", display: "block" }}
                onClick={riskProfileClickHandler}
                role="button"
            >
                <strong>
                    <i
                        className="bi bi-info-circle pe-1 text-secondary"
                        title="Please always remain vigilant and cautious. Regardless of the risk level, it is important to stay alert and aware of your surroundings."
                    ></i>
                    <i
                        className="bi bi-circle-fill pe-1 text-success"
                        title="Safe"
                    ></i>
                    <i
                        className="bi bi-circle-fill pe-1 text-info"
                        title="Okay"
                    ></i>
                    <i
                        className="bi bi-circle-fill pe-1 text-warning"
                        title="Caution"
                    ></i>
                    <i
                        className="bi bi-circle-fill pe-1 text-danger"
                        title="Danger"
                    ></i>
                </strong>
            </div>
        </>
    )
}
